// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import VueResource from 'vue-resource'
import '@/styles/custom.scss' // 自定义 css
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

Vue.use(ElementUI)
Vue.use(VueResource)

// 根据路由设置标题
router.beforeEach((to, from, next) => {
    /*路由发生改变修改页面的title */
    if (to.meta.title) {
        document.title = to.meta.title + " - 锅巴汉化 - g8hh.com - Git游戏 - gityx.com"
    }
    next();
})


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js